import styled from 'styled-components';

export const MultiEllipsisContainer = styled.div`
  .MultiEllipsis__Markdown {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 26px;
    text-align: justify; /* 浏览器可能不支持 */
    text-transform: lowercase;
    letter-spacing: normal;
    /* 中性色/color-text */
    color: rgba(38, 36, 76, 0.88);
  }
`;
